import { TalentImportPage } from "@/features/talent/pages/TalentImport";

const TalentImport = () => {
  return <TalentImportPage />;
};

export default TalentImport;
